import { render, staticRenderFns } from "./AddSaleRate.vue?vue&type=template&id=149b4fac&scoped=true&"
import script from "./AddSaleRate.vue?vue&type=script&lang=js&"
export * from "./AddSaleRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149b4fac",
  null
  
)

export default component.exports